import $ from 'jquery'

class Module {
  constructor ($module, $balance) {
    this.$switcher = $module.find('.b-wallet__hdr')
    this.$currency = $module.find('.js-currency')
    this.$balance = $balance
    this.$depositLinks = $module.find('.js-deposit')
    this.$withdrawalLinks = $module.find('.js-withdrawal')
    this.bind()
  }

  bind () {
    const self = this

    this.$currency.on('click', function (event) {
      //event.preventDefault()

      const $link = $(this)
      const activeClass = 'active'

      if (!$link.hasClass(activeClass)) {
        const deposit = $link.data('deposit')
        const $target = $($link.data('target'))
        const className = 'b-wallet__sum_inactive'
        let linkOffset = $link.position().left

        self.$depositLinks.attr('href', deposit)
        self.$balance.html($target.find('.value').html())

        $target.removeClass(className)

        self.$switcher.find('.' + activeClass).removeClass(activeClass)
        $link.addClass(activeClass)

        if (linkOffset > 0) {
          linkOffset -= 60
        }

        $('.b-wallet__scroller').get(0).style.left = '-' + linkOffset + 'px'
        $link.trigger('changeCurrency')
      }
    }).on('changeCurrency', function () {
      const $link = $(this)
      const depositUrl = $link.data('deposit-url')
      const withdrawalUrl = $link.data('withdrawal-url')
      
      self.$depositLinks.each(function () {
        if (depositUrl) {
          $(this).removeClass('hidden')
          $(this).parent().removeClass('hidden')
        } else {
          $(this).addClass('hidden')
          $(this).parent().addClass('hidden')
        }

        $(this).attr('href', depositUrl)
      })

      self.$withdrawalLinks.each(function () {
        if (withdrawalUrl) {
          $(this).removeClass('hidden')
        } else {
          $(this).addClass('hidden')
        }

        $(this).attr('href', withdrawalUrl)
      })
    })

    const $active = this.$currency.filter('.active')
    this.$depositLinks.attr('href', $active.data('deposit-url'))
  }
}

$(function () {
  $('.b-wallet').each(function () {
    new Module($(this), $('.js-account-balance'))
  })
})
